/* Gloorlicht — comportements de la vitrine (révélations, galerie, vidéos, offres, barre d'achat). */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Révélation au défilement
  const io = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px' }) : null;
  document.querySelectorAll('[data-a-reveal]').forEach((el) => (io && !reduce ? io.observe(el) : el.classList.add('is-in')));

  // Fiche : délai de livraison réel, en jours ouvrés à partir d'aujourd'hui (aucune fausse rareté)
  document.querySelectorAll('[data-a-eta]').forEach((box) => {
    const addDays = (n) => { const d = new Date(); let k = 0; while (k < n) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) k++; } return d; };
    const fmt = (d) => d.toLocaleDateString('nl-NL', { day: 'numeric', month: 'short' }).replace('.', '');
    const min = +box.dataset.min || 7, max = +box.dataset.max || 12;
    const from = addDays(min), to = addDays(max);
    box.querySelector('[data-a-eta-ship]').textContent = `Vóór ${fmt(addDays(3))}`;
    box.querySelector('[data-a-eta-to]').textContent = `${fmt(from)} – ${fmt(to)}`;
    box.style.setProperty('--w', '34%');
    if (io && !reduce) io.observe(box); else box.classList.add('is-in');
  });

  // Fiche : vidéos « en action », lues au toucher (une seule à la fois)
  document.querySelectorAll('[data-a-clips]').forEach((row) => {
    const clips = [...row.querySelectorAll('.a-clip')];
    clips.forEach((c) => {
      const v = c.querySelector('video');
      if (!v) return;
      c.addEventListener('click', () => {
        if (!v.src) v.src = v.dataset.src;
        const on = v.paused;
        clips.forEach((o) => { const ov = o.querySelector('video'); if (ov && ov !== v) { ov.pause(); o.classList.remove('is-playing'); } });
        if (on) { v.play().catch(() => {}); c.classList.add('is-playing'); } else { v.pause(); c.classList.remove('is-playing'); }
      });
    });
  });

  // Fiche : avis façon Versio. On lit les avis Judge.me (API publique du widget) et on les range nous-mêmes :
  // d'abord les avis 4-5★ avec photo, puis tous les autres par meilleure note. Tous les avis restent affichés.
  document.querySelectorAll('#avis.a-reviews--pill[data-pid]').forEach(async (sec) => {
    const api = (p) => `https://cdn.judge.me/reviews/reviews_for_widget?product_id=${sec.dataset.pid}&shop_domain=${sec.dataset.shop}&platform=shopify&page=${p}&per_page=30&sort_by=highest_rating`;
    let all = [];
    try {
      for (let p = 1; p <= 10; p++) {
        const d = await (await fetch(api(p))).json();
        all = all.concat(d.reviews || []);
        if (!d.pagination || p >= d.pagination.total_pages) break;
      }
    } catch (e) { return; } // en cas d'échec, le widget Judge.me reste affiché tel quel
    if (!all.length) return;
    let NLT = {};
    try { if (sec.dataset.nl) NLT = await (await fetch(sec.dataset.nl)).json(); } catch (e) {} // avis traduits du français (version NL)
    const txt = (html) => (new DOMParser().parseFromString(html || '', 'text/html').body.textContent || '').trim();
    const rows = all.map((r) => {
      let body = txt(r.body_html);
      const translated = !!NLT[r.uuid];
      if (translated) body = NLT[r.uuid];
      if (body.length < 40 && /r[ée]veil lumi[èe]re$/i.test(body)) body = ''; // avis importés sans texte : le nom du produit à la place
      const pic = sec.dataset.photos === '1' && r.pictures_urls && r.pictures_urls[0] ? (r.pictures_urls[0].huge || r.pictures_urls[0].original) : '';
      const ali = /ali\s*express/i.test(body + ' ' + txt(r.body_html)) ? 1 : 0; // avis qui citent AliExpress : gardés, mais en dernier
      return { r, body, pic, rating: +r.rating || 0, translated, ali };
    }).filter((x) => x.body || x.pic);
    const top = (x) => (x.pic && x.rating >= 4 ? 1 : 0);
    rows.sort((a, b) => a.ali - b.ali || top(b) - top(a) || b.rating - a.rating || (b.body ? 1 : 0) - (a.body ? 1 : 0) || b.body.length - a.body.length);

    const wrap = document.createElement('div');
    wrap.className = 'lm-rv-wrap';
    wrap.innerHTML = '<div class="lm-rv-nav"><button type="button" aria-label="Vorige review">‹</button><button type="button" aria-label="Volgende review">›</button></div><div class="lm-rv-list" tabindex="0" aria-label="Klantreviews"></div>';
    const list = wrap.querySelector('.lm-rv-list');
    rows.forEach(({ r, body, pic, rating, translated }) => {
      const name = (r.reviewer_name || '').trim();
      const p = name.split(/\s+/);
      const short = p[0] + (p[1] ? ' ' + p[1][0].toUpperCase() + '.' : '');
      const item = document.createElement('div');
      item.className = 'lm-rv-item';
      item.innerHTML = (pic ? '<div class="lm-rv__ph"><img alt="Foto van de koper" loading="lazy"></div>' : '')
        + '<div class="lm-rv__top"><span class="lm-rv__av"></span><span class="lm-rv__who"><b></b><small></small></span><span class="a-stars lm-rv__st" role="img"></span></div>'
        + (body ? '<p class="lm-rv__tx"></p><button type="button" class="lm-rv__more" hidden>Lees meer</button>' : '')
        + (translated ? '<p class="lm-rv__tr">Vertaald uit het Frans</p>' : '');
      if (pic) item.querySelector('img').src = pic;
      item.querySelector('.lm-rv__av').textContent = (short[0] || '?').toUpperCase();
      item.querySelector('b').textContent = short;
      item.querySelector('small').textContent = r.created_at ? new Date(r.created_at).toLocaleDateString('nl-NL', { day: 'numeric', month: 'short', year: 'numeric' }) : '';
      const st = item.querySelector('.lm-rv__st');
      st.style.setProperty('--r', (rating / 5) * 100 + '%');
      st.setAttribute('aria-label', rating + ' van 5');
      if (body) {
        const tx = item.querySelector('.lm-rv__tx');
        const more = item.querySelector('.lm-rv__more');
        tx.textContent = body;
        more.addEventListener('click', () => { const open = tx.classList.toggle('is-open'); more.textContent = open ? 'Minder' : 'Lees meer'; });
      }
      list.append(item);
    });
    const widget = sec.querySelector('.a-reviews__widget');
    (widget || sec.querySelector('.a-wrap')).before(wrap);
    sec.classList.add('lm-own');
    list.querySelectorAll('.lm-rv__tx').forEach((tx) => { if (tx.scrollHeight > tx.clientHeight + 2) tx.nextElementSibling.hidden = false; });
    const center = () => { const b = list.getBoundingClientRect(); const mid = b.left + b.width / 2; let best, d = 1e9;
      [...list.children].forEach((c) => { const x = Math.abs(c.getBoundingClientRect().left + c.offsetWidth / 2 - mid); if (x < d) { d = x; best = c; } });
      [...list.children].forEach((c) => c.classList.toggle('is-center', c === best)); };
    list.addEventListener('scroll', () => requestAnimationFrame(center), { passive: true });
    window.addEventListener('resize', center);
    center();
    const step = () => (list.children[0]?.offsetWidth || 300) + 16;
    const nav = wrap.querySelector('.lm-rv-nav');
    nav.children[0].addEventListener('click', () => list.scrollBy({ left: -step(), behavior: 'smooth' }));
    nav.children[1].addEventListener('click', () => list.scrollBy({ left: step(), behavior: 'smooth' }));
  });

  // Version NL : le widget Judge.me (réglé en français dans l'appli) — on traduit son bouton visible
  if (document.querySelector('#avis')) {
    let n = 0;
    const iv = setInterval(() => {
      document.querySelectorAll('#avis .jm-button, #avis button').forEach((b) => {
        if (b.textContent.trim() === 'Écrire un avis') b.querySelectorAll('*').length ? b.querySelectorAll('span, .jm-text').forEach((x) => { if (x.textContent.trim() === 'Écrire un avis') x.textContent = 'Schrijf een review'; }) : (b.textContent = 'Schrijf een review');
      });
      if (++n > 40) clearInterval(iv);
    }, 250);
  }

  // Version NL : le formulaire « Écrire un avis » de Judge.me (réglé en français dans l'appli) traduit à l'affichage
  {
    const JM = {
      "You've already reviewed this product from this device. Do you want to write another review?": 'Je hebt dit product op dit apparaat al beoordeeld. Wil je nog een review schrijven?',
      'Write another review': 'Nog een review schrijven', 'Not now': 'Niet nu',
      'Comment évalueriez-vous ce produit ?': 'Hoe zou je dit product beoordelen?',
      'Nous serions ravis que vous partagiez un peu votre expérience.': 'We horen graag hoe je het product ervaart.',
      "Contenu de l'avis (Obligatoire)": 'Je review (verplicht)',
      'Nous vous contacterons uniquement au sujet de votre avis si nécessaire. En soumettant votre avis, vous acceptez nos': 'We nemen alleen contact met je op over je review als dat nodig is. Door je review te versturen, ga je akkoord met onze',
      "conditions d'utilisation": 'gebruiksvoorwaarden', 'et notre': 'en ons', 'politique de confidentialité': 'privacybeleid',
      'À propos de vous': 'Over jou', 'Veuillez nous en dire plus sur vous.': 'Vertel ons iets meer over jezelf.',
      'Adresse email (Obligatoire)': 'E-mailadres (verplicht)', 'Nous respectons votre vie privée.': 'We respecteren je privacy.',
      "Nom d'affichage (Obligatoire)": 'Weergavenaam (verplicht)', 'Ne sera pas visible pour les autres clients.': 'Niet zichtbaar voor andere klanten.',
      'Avis anonyme': 'Anonieme review', 'Partager une photo ou une vidéo': 'Deel een foto of video',
      'Téléchargez une photo ou une vidéo pour étayer votre avis.': 'Upload een foto of video bij je review.',
      'Cliquez pour télécharger': 'Klik om te uploaden', 'ou glissez-déposez': 'of sleep je bestand hierheen',
      'Retour': 'Terug', 'Suivant': 'Volgende', 'Envoyer': 'Versturen', 'Soumettre': 'Versturen', "Soumettre l'avis": 'Review versturen',
      'Merci pour votre avis !': 'Bedankt voor je review!',
      'Nous le traitons et il apparaîtra bientôt dans la boutique.': 'We verwerken hem en hij verschijnt binnenkort in de winkel.',
      'Veuillez confirmer votre email en cliquant sur le lien que nous venons de vous envoyer. Cela nous aide à maintenir des avis authentiques.': 'Bevestig je e-mailadres via de link die we je net hebben gestuurd. Zo houden we de reviews echt.',
      "Aimeriez-vous partager votre expérience d'achat avec nous ?": 'Wil je je aankoopervaring met ons delen?',
      "Nous apprécions votre retour d'expérience et nous l'utilisons pour nous améliorer. Veuillez partager vos pensées ou suggestions.": 'We waarderen je feedback en gebruiken die om beter te worden. Deel gerust je gedachten of suggesties.',
      'Fermer': 'Sluiten', 'Mauvais': 'Slecht', 'Excellent': 'Uitstekend', 'Médiocre': 'Matig', 'Moyen': 'Gemiddeld', 'Bien': 'Goed', 'Très bien': 'Heel goed',
      'Commencez à écrire ici...': 'Begin hier te schrijven...', 'Votre adresse email': 'Je e-mailadres', "Nom d'affichage": 'Weergavenaam',
      'Collez votre URL Youtube ici': 'Plak hier je YouTube-link',
      'Close review form': 'Reviewformulier sluiten', 'Previous step': 'Vorige stap', 'Next step': 'Volgende stap',
      'Avis Clients': 'Klantreviews', 'Écrire un avis': 'Schrijf een review', 'Plus récents': 'Nieuwste', 'Meilleures notes': 'Hoogste beoordeling',
      'Notes les plus basses': 'Laagste beoordeling', 'Uniquement les photos': "Alleen foto's", 'Photos en premier': "Foto's eerst", 'Vidéos en premier': "Video's eerst", 'Plus utiles': 'Meest nuttig',
      'Sorted by Meilleures notes': 'Gesorteerd op hoogste beoordeling',
      '1 star': '1 ster', '2 stars': '2 sterren', '3 stars': '3 sterren', '4 stars': '4 sterren', '5 stars': '5 sterren',
    };
    const fix = (root) => {
      const w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let n;
      while ((n = w.nextNode())) { const v = n.nodeValue.trim(); if (JM[v]) n.nodeValue = n.nodeValue.replace(v, JM[v]); else if (/^\d+ avis$/.test(v)) n.nodeValue = n.nodeValue.replace('avis', 'reviews'); }
      [root, ...root.querySelectorAll('[placeholder],[aria-label],[title]')].forEach((e) => ['placeholder', 'aria-label', 'title'].forEach((a) => { const v = e.getAttribute(a); if (v && JM[v]) e.setAttribute(a, JM[v]); }));
    };
    let busy = false;
    new MutationObserver(() => {
      if (busy) return;
      const m = document.querySelectorAll('.jdgm-write-review-modal, .jdgm-rev-widg, .jdgm-prev-badge, .jdgm-widget, [class*="jm-review-widget"]');
      if (!m.length) return;
      busy = true; m.forEach(fix); busy = false;
    }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  }

  // Vidéos muettes : chargées et lues seulement quand elles sont visibles
  const vids = document.querySelectorAll('video[data-a-video]');
  if ('IntersectionObserver' in window) {
    const vo = new IntersectionObserver((entries) => {
      entries.forEach(({ target: v, isIntersecting }) => {
        if (isIntersecting) {
          if (!v.src && v.dataset.src) v.src = v.dataset.src;
          if (!reduce) v.play().catch(() => {});
        } else if (!v.paused) v.pause();
      });
    }, { rootMargin: '200px 0px' });
    vids.forEach((v) => vo.observe(v));
  } else vids.forEach((v) => { v.src = v.dataset.src; });

  // Galerie produit
  document.querySelectorAll('[data-a-gallery]').forEach((g) => {
    const track = g.querySelector('.a-gal__track');
    const slides = [...track.children];
    const marks = [...g.querySelectorAll('[data-a-go]')];
    let cur = 0;
    const go = (i, smooth = true) => {
      cur = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[cur].offsetLeft, behavior: smooth && !reduce ? 'smooth' : 'auto' });
    };
    const sync = () => {
      const i = Math.round(track.scrollLeft / track.clientWidth);
      cur = i;
      marks.forEach((m) => m.setAttribute('aria-current', String(+m.dataset.aGo === i)));
      slides.forEach((s, k) => { const v = s.querySelector('video'); if (v) { if (k === i) { if (!v.src) v.src = v.dataset.src; v.play().catch(() => {}); } else v.pause(); } });
    };
    let t; track.addEventListener('scroll', () => { clearTimeout(t); t = setTimeout(sync, 60); }, { passive: true });
    marks.forEach((m) => m.addEventListener('click', () => go(+m.dataset.aGo)));
    g.querySelector('.a-gal__nav--prev')?.addEventListener('click', () => go(cur - 1));
    g.querySelector('.a-gal__nav--next')?.addEventListener('click', () => go(cur + 1));
    g.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') go(cur + 1); if (e.key === 'ArrowLeft') go(cur - 1); });
    sync();
  });

  // Offres 1 ou 2 réveils : règle la quantité du formulaire et le texte du bouton
  document.querySelectorAll('[data-a-buy]').forEach((buy) => {
    const qty = buy.querySelector('input[name="quantity"]');
    const label = buy.querySelector('[data-a-atc-label]');
    const sync = () => {
      const r = buy.querySelector('input[name="a-pack"]:checked');
      if (!r) return;
      qty.value = r.value;
      if (label) label.textContent = `${label.dataset.base} · ${r.dataset.total}`;
    };
    buy.querySelectorAll('input[name="a-pack"]').forEach((r) => r.addEventListener('change', sync));
    sync();
  });

  // Ciel : la page passe de la nuit à l'aube avec le défilement
  const root = document.documentElement;
  if (document.querySelector('.a-sky') && !reduce) {
    let raf = 0;
    const sky = () => { raf = 0; const max = document.body.scrollHeight - innerHeight; root.style.setProperty('--p', Math.min(1, Math.max(0, scrollY / (max || 1))).toFixed(3)); };
    addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(sky); }, { passive: true });
    sky();
  } else root.style.setProperty('--p', '.6');

  // Simulateur de lever de soleil : la lumière monte pendant la durée choisie, en accéléré
  document.querySelectorAll('[data-a-sim]').forEach((stage) => {
    const wrap = stage.closest('section');
    const range = wrap.querySelector('[data-a-sim-range]');
    const out = wrap.querySelector('[data-a-sim-out]');
    const clock = stage.querySelector('[data-a-sim-clock]');
    const phase = stage.querySelector('[data-a-sim-phase]');
    const play = wrap.querySelector('[data-a-sim-play]');
    const [ah, am] = (stage.dataset.alarm || '07:00').split(':').map(Number);
    const alarm = ah * 60 + am;
    const fmt = (m) => `${String(Math.floor(m / 60) % 24).padStart(2, '0')}:${String(Math.round(m) % 60).padStart(2, '0')}`;
    let t = 0, anim = 0;
    const draw = () => {
      const d = +range.value;
      const now = alarm - d + t * d;
      const l = Math.pow(t, 1.6);
      stage.style.setProperty('--l', l.toFixed(3));
      stage.style.setProperty('--t', t.toFixed(3));
      clock.textContent = fmt(now);
      phase.textContent = t <= 0 ? 'Nacht' : t >= 1 ? 'Alarm: opstaan!' : `Licht ${Math.round(l * 100)}%`;
      stage.classList.toggle('is-awake', t >= 1);
      out.textContent = `${Math.round(d / 10) * 10} min`;
    };
    const run = () => {
      cancelAnimationFrame(anim);
      if (reduce) { t = 1; draw(); return; }
      const start = performance.now(), dur = 4200;
      const step = (now) => { t = Math.min(1, (now - start) / dur); draw(); if (t < 1) anim = requestAnimationFrame(step); };
      anim = requestAnimationFrame(step);
    };
    // Curseur fluide ; au relâchement il glisse jusqu'au réglage réel le plus proche (l'appareil se règle par 10 min)
    let snapAnim = 0;
    range.addEventListener('input', () => { cancelAnimationFrame(snapAnim); t = 0; draw(); });
    const snap = () => {
      const from = +range.value, to = Math.round(from / 10) * 10;
      if (reduce || from === to) { range.value = to; draw(); return; }
      const t0 = performance.now();
      const step = (now) => { const k = Math.min(1, (now - t0) / 260); range.value = from + (to - from) * (1 - Math.pow(1 - k, 3)); draw(); if (k < 1) snapAnim = requestAnimationFrame(step); };
      snapAnim = requestAnimationFrame(step);
    };
    range.addEventListener('change', snap);
    play.addEventListener('click', run);
    draw();
    if ('IntersectionObserver' in window) {
      const once = new IntersectionObserver(([e]) => { if (e.isIntersecting) { run(); once.disconnect(); } }, { threshold: .5 });
      once.observe(stage);
    }
  });

  // Menu mobile : le lien touché s'allume (le temps du toucher, et un peu après)
  document.querySelectorAll('.menu-drawer__menu-item').forEach((a) => {
    a.addEventListener('pointerdown', () => a.classList.add('is-lit'));
    ['pointerup', 'pointercancel', 'pointerleave'].forEach((t) => a.addEventListener(t, () => setTimeout(() => a.classList.remove('is-lit'), 350)));
  });

  // Pages juridiques : sommaire construit à partir des titres, qui suit la lecture
  document.querySelectorAll('[data-a-toc]').forEach((toc) => {
    const doc = document.querySelector('[data-a-toc-src]');
    const hs = doc ? [...doc.querySelectorAll('h2')] : [];
    if (hs.length < 2) { toc.hidden = true; return; }
    const ol = toc.querySelector('ol');
    const links = hs.map((h, i) => {
      h.id = h.id || `section-${i + 1}`;
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = `#${h.id}`;
      a.textContent = h.textContent.replace(/^\d+\.\s*/, '');
      li.append(a); ol.append(li);
      return a;
    });
    if (!('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver((es) => {
      es.forEach((e) => {
        if (!e.isIntersecting) return;
        const i = hs.indexOf(e.target);
        links.forEach((l, j) => l.classList.toggle('is-on', j === i));
        if (toc.scrollWidth > toc.clientWidth) toc.scrollTo({ left: links[i].parentElement.offsetLeft - (toc.clientWidth - links[i].offsetWidth) / 2, behavior: reduce ? 'auto' : 'smooth' });
      });
    }, { rootMargin: '-20% 0px -70% 0px' });
    hs.forEach((h) => io.observe(h));
  });

  // Onglets de la fiche (flèches gauche/droite au clavier)
  document.querySelectorAll('[data-a-tabs]').forEach((box) => {
    const tabs = [...box.querySelectorAll('[role="tab"]')];
    const show = (t) => {
      tabs.forEach((x) => {
        const on = x === t;
        x.setAttribute('aria-selected', String(on));
        x.tabIndex = on ? 0 : -1;
        document.getElementById(x.getAttribute('aria-controls')).hidden = !on;
      });
      t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: reduce ? 'auto' : 'smooth' });
    };
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => show(t));
      t.addEventListener('keydown', (e) => {
        const d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        const n = tabs[(i + d + tabs.length) % tabs.length];
        show(n); n.focus();
      });
    });
  });

  // 12 couleurs : la veilleuse et le reste du site prennent la teinte choisie
  document.querySelectorAll('[data-a-colors-stage]').forEach((stage) => {
    const wrap = stage.closest('section');
    const code = stage.querySelector('[data-a-colors-code]');
    wrap.querySelectorAll('[data-a-swatch]').forEach((b) => b.addEventListener('click', () => {
      wrap.querySelectorAll('[data-a-swatch]').forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
      stage.style.setProperty('--c', b.dataset.aSwatch);
      root.style.setProperty('--glow', b.dataset.aSwatch);
      code.textContent = b.dataset.code;
    }));
  });


  // Avis Judge.me : tri par défaut « Meilleures notes » (le carrousel façon Versio fait son propre ordre : photos 4-5★ d'abord) (affiché dans le menu de tri, modifiable par le visiteur)
  const sortReviews = () => {
    const sel = document.querySelector('#avis .jm-sort-filter__select');
    if (!sel) return false;
    if (sel.value !== 'highest_rating' && [...sel.options].some((o) => o.value === 'highest_rating')) {
      sel.value = 'highest_rating';
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    }
    return true;
  };
  if (document.querySelector('#avis')) {
    let tries = 0;
    const iv = setInterval(() => { if (sortReviews() || ++tries > 40) clearInterval(iv); }, 250);
  }

  // Panier : « Ajoutez un 2e réveil » passe la quantité à 2 sans quitter le tiroir / la page panier
  document.addEventListener('click', (e) => {
    const duo = e.target.closest('.a-cartnote__duo');
    if (!duo) return;
    const items = duo.closest('cart-drawer') ? document.querySelector('cart-drawer-items') : document.querySelector('cart-items');
    if (!items || typeof items.updateQuantity !== 'function') return;
    e.preventDefault();
    duo.classList.add('is-loading');
    duo.setAttribute('aria-busy', 'true');
    // Dawn compare la quantité reçue à celle du champ : on l'aligne pour éviter un faux message d'erreur
    const q = items.querySelector('#Drawer-quantity-1, #Quantity-1');
    if (q) q.value = 2;
    items.updateQuantity(1, 2, { currentTarget: duo }, 'quantity');
  });

  // En-tête : un halo de lumière suit la souris
  const hw = document.querySelector('.section-header .header-wrapper');
  if (hw && matchMedia('(hover: hover)').matches) {
    hw.addEventListener('pointermove', (e) => {
      const r = hw.getBoundingClientRect();
      hw.classList.add('is-lit');
      hw.style.setProperty('--hx', `${e.clientX - r.left}px`);
      hw.style.setProperty('--hy', `${e.clientY - r.top}px`);
    });
    hw.addEventListener('pointerleave', () => hw.classList.remove('is-lit'));
  }

  // Barre d'annonce : un message à la fois
  document.querySelectorAll('[data-a-announce]').forEach((bar) => {
    const items = [...bar.querySelectorAll('.a-announce__item')];
    if (items.length < 2 || reduce) return;
    let i = 0;
    setInterval(() => {
      const cur = items[i], next = items[(i + 1) % items.length];
      cur.classList.remove('is-on'); cur.classList.add('is-out'); cur.setAttribute('aria-hidden', 'true'); cur.tabIndex = -1;
      next.classList.remove('is-out'); next.classList.add('is-on'); next.removeAttribute('aria-hidden'); next.removeAttribute('tabindex');
      setTimeout(() => cur.classList.remove('is-out'), 650);
      i = (i + 1) % items.length;
    }, 4000);
  });

  // Barre d'achat collante : visible quand le bouton principal sort de l'écran (et avant le pied de page)
  const sticky = document.querySelector('[data-a-sticky]');
  const anchor = document.querySelector('[data-a-buy] .product-form__submit');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    let pastBtn = false, nearEnd = false;
    const upd = () => sticky.classList.toggle('is-on', pastBtn && !nearEnd);
    new IntersectionObserver(([e]) => { pastBtn = !e.isIntersecting && e.boundingClientRect.top < 0; upd(); }).observe(anchor);
    const foot = document.querySelector('footer');
    if (foot) new IntersectionObserver(([e]) => { nearEnd = e.isIntersecting; upd(); }).observe(foot);
    sticky.querySelector('[data-a-sticky-go]')?.addEventListener('click', (e) => {
      e.preventDefault();
      const f = document.querySelector('[data-a-buy]');
      f.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    });
  }
})();
